<div class="main-content">

	<div class="container-fluid tp-box" [@flipState]="flip">
		<div class="row backside tp-box__side tp-box__back" [ngClass]="flip != 'inactive' ? '' : 'd-none'">
			<div class="col-12">
				<div class="cw-wrap id-flip-back" [ngStyle]="flipThemeVars">
					<div class="cw-icon-badge pointer" (click)="closeFlip()" title="Back">
						<i class="material-icons">arrow_back</i>
					</div>
					<div class="cw-header">
						<div class="cw-title-group">
							<span class="cw-title">{{ viewing }}</span>
						</div>
					</div>
					<div class="cw-body">
						<ng-container [ngSwitch]="viewing">
							<app-inventory-export *ngSwitchCase="'All Items'" [data]="allitems"></app-inventory-export>
							<ng-container *ngSwitchCase="'Need Bin Location'">
								<app-need-bin-location></app-need-bin-location>
							</ng-container>
							<ng-container *ngSwitchCase="'Negative Stock'">
								<app-negative-items></app-negative-items>
							</ng-container>
							<app-missingpurchdata *ngSwitchCase="'Missing Purchasing Data'" [data]="missingpurch"></app-missingpurchdata>
							<app-missingimages *ngSwitchCase="'Missing Images'"></app-missingimages>
							<app-missingimages-no-attr [items_input]="imageMangerItems" [loading]="imagemangerloading" (missingimages)="imagemangermissing = $event" *ngSwitchCase="'Image Manager'"></app-missingimages-no-attr>
							<app-boms *ngSwitchCase="'boms'" [data]="boms"></app-boms>
							<app-zero-cost *ngSwitchCase="'Zero Cost'" [data]="zerocost"></app-zero-cost>
							<inventory-remote-new-items *ngSwitchCase="'New Available Items'" [data]="remotenewitems"></inventory-remote-new-items>
							<app-item-missingbrands *ngSwitchCase="'Missing Brands'" [data]="missingbrands"></app-item-missingbrands>
						</ng-container>
					</div>
				</div>
			</div>
		</div>

		<div class="row tp-box__side tp-box__front inventory-dashboard-row" id="frontside">
			<div class="col-lg-4 col-md-4 col-sm-4 dashboard-stat-col">
				<app-dashboard-stat-card
					title="All Items"
					icon="content_copy"
					accent="success"
					[value]="getCount(allitems)"
					[loading]="isNotReady(allitems)"
					[showView]="!isNotReady(allitems)"
					(view)="toggleFlip('All Items')">
				</app-dashboard-stat-card>
			</div>

			<div class="col-lg-4 col-md-4 col-sm-4 dashboard-stat-col">
				<app-dashboard-stat-card
					title="Need Bin Location"
					icon="store"
					accent="warning"
					[value]="getCount(needlocation)"
					[loading]="isNotReady(needlocation)"
					[showView]="!isNotReady(needlocation)"
					(view)="toggleFlip('Need Bin Location')">
				</app-dashboard-stat-card>
			</div>

			<div class="col-lg-4 col-md-4 col-sm-4 dashboard-stat-col">
				<app-dashboard-stat-card
					title="Negative Items"
					icon="content_copy"
					accent="success"
					[value]="getCount(negativestock)"
					[loading]="isNotReady(negativestock)"
					[showView]="!isNotReady(negativestock)"
					(view)="toggleFlip('Negative Stock')">
				</app-dashboard-stat-card>
			</div>

			<div class="col-lg-4 col-md-4 col-sm-4 dashboard-stat-col">
				<app-dashboard-stat-card
					title="Missing Purchasing Data"
					icon="shop_two"
					accent="danger"
					[value]="getCount(missingpurch)"
					[loading]="isNotReady(missingpurch)"
					[showView]="!isNotReady(missingpurch)"
					(view)="toggleFlip('Missing Purchasing Data')">
				</app-dashboard-stat-card>
			</div>

			<div class="col-lg-4 col-md-4 col-sm-4 dashboard-stat-col" *ngIf="config.env.package == 'tires'">
				<app-dashboard-stat-card
					title="Missing Attributes/Images"
					icon="image"
					accent="primary"
					[value]="missingImagesTotal"
					[loading]="isNotReady(missingimages)"
					[buckets]="missingImagesBuckets"
					[showView]="!isNotReady(missingimages)"
					(view)="toggleFlip('Missing Images')">
				</app-dashboard-stat-card>
			</div>

			<div class="col-lg-4 col-md-4 col-sm-4 dashboard-stat-col" *ngIf="config.env.package == 'beauty'">
				<app-dashboard-stat-card
					title="Missing Images"
					icon="image"
					accent="primary"
					[value]="imagemangermissing || null"
					[loading]="imagemangerloading === 'notready' && !imageMangerItems"
					[showView]="!!imageMangerItems?.length || imagemangermissing > 0"
					(view)="toggleFlip('Image Manager')">
				</app-dashboard-stat-card>
			</div>

			<div class="col-lg-4 col-md-4 col-sm-4 dashboard-stat-col">
				<app-dashboard-stat-card
					title="BOMs"
					icon="list_alt"
					accent="primary"
					[showView]="true"
					(view)="toggleFlip('boms')">
				</app-dashboard-stat-card>
			</div>

			<div class="col-lg-4 col-md-4 col-sm-4 dashboard-stat-col">
				<app-dashboard-stat-card
					title="Zero Cost"
					icon="attach_money"
					accent="danger"
					[value]="getCount(zerocost)"
					[loading]="isNotReady(zerocost)"
					[showView]="!isNotReady(zerocost)"
					(view)="toggleFlip('Zero Cost')">
				</app-dashboard-stat-card>
			</div>

			<div class="col-lg-4 col-md-4 col-sm-4 dashboard-stat-col">
				<app-dashboard-stat-card
					title="New Available Items"
					icon="add_box"
					accent="success"
					[value]="getCount(remotenewitems)"
					[loading]="isNotReady(remotenewitems)"
					[showView]="!isNotReady(remotenewitems)"
					(view)="toggleFlip('New Available Items')">
				</app-dashboard-stat-card>
			</div>

			<div class="col-lg-4 col-md-4 col-sm-4 dashboard-stat-col">
				<app-dashboard-stat-card
					title="Missing Brands"
					icon="category"
					accent="success"
					[value]="getCount(missingbrands)"
					[loading]="isNotReady(missingbrands)"
					[showView]="!isNotReady(missingbrands)"
					(view)="toggleFlip('Missing Brands')">
				</app-dashboard-stat-card>
			</div>
		</div>
	</div>
</div>
